import { connect } from 'react-redux';
import Section from '../components/Section';
import { switchLineInSection } from '../actions/sections';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  lines: ownProps.section.lines.map(lineId => state.song.lines.byId[lineId]),
  ui: state.ui,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onReplaceLine: (lineIndex, newLineId) => {
    dispatch(switchLineInSection(ownProps.id, lineIndex, newLineId));
  },
});

const SectionContainer = connect(mapStateToProps, mapDispatchToProps)(Section);

export default SectionContainer;



// WEBPACK FOOTER //
// ./src/containers/SectionContainer.js